var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7511296,0.876364317 L5.7511296,1.42408752 C5.7511296,1.90677504 4.54898775,2.30045184 3.06726912,2.30045184 C1.58555049,2.30045184 0.38340864,1.90677504 0.38340864,1.42408752 L0.38340864,0.876364317 C0.38340864,0.393676803 1.58555049,0 3.06726912,0 C4.54898775,0 5.7511296,0.393676803 5.7511296,0.876364317 Z M5.7511296,2.10874752 L5.7511296,3.34113072 C5.7511296,3.82381824 4.54898775,4.21749504 3.06726912,4.21749504 C1.58555049,4.21749504 0.38340864,3.82381824 0.38340864,3.34113072 L0.38340864,2.10874752 C0.96001929,2.50585104 2.01538752,2.69071391 3.06726912,2.69071391 C4.11915072,2.69071391 5.17450697,2.50585104 5.7511296,2.10874752 Z M5.7511296,4.02579072 L5.7511296,5.25817392 C5.7511296,5.74086144 4.54898775,6.13453824 3.06726912,6.13453824 C1.58555049,6.13453824 0.38340864,5.74086144 0.38340864,5.25817392 L0.38340864,4.02579072 C0.96001929,4.42289424 2.01538752,4.60775711 3.06726912,4.60775711 C4.11915072,4.60775711 5.17450697,4.42289424 5.7511296,4.02579072 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.3b036d5c971d8f2b10d2988dab714bf8.svg";
export { ForwardRef as ReactComponent };